import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'
import { DangerButton, LightButton, NeutralButton } from 'shared/components/button'
import { PrimaryButton } from 'shared/components/button'
import Modal from 'shared/components/modal'
import useUser from 'shared/hooks/use-user'
import ShapeIcon from 'shared/icons/shape-icon'
import useIsUserMember from '../hooks/use-is-user-member'
import { CommunityInterface } from '../types/community-interface'

interface CommunityCartProps {
  community: CommunityInterface
  onLeaveCommunity: (community: CommunityInterface) => void
  isFetching: boolean
}

const CommunityCart = ({ community, onLeaveCommunity, isFetching }: CommunityCartProps) => {
  const { t } = useTranslation()
  const { isOwner } = useUser()

  const [opened, setOpened] = useState<boolean>(false)

  const { isUserMember } = useIsUserMember(community.path, () => {}, false)

  return (
    <>
      <div className="group relative w-full max-w-[385px] overflow-hidden rounded-lg bg-background-secondary">
        {!isOwner && isUserMember && (
          <LightButton
            className="absolute right-3 top-3 hidden hover:bg-background-secondary group-hover:block"
            onClick={() => setOpened(true)}
          >
            <ShapeIcon className="hover:fill-danger" />
          </LightButton>
        )}
        {community.imagePath ? (
          <img src={community.imagePath} alt={community.name} className="w-full" />
        ) : (
          <img src="/demo_community_image.png" alt={community.name} />
        )}
        <div className="px-5 py-6">
          <Link
            href={`/community/${community.path}`}
            className="mb-3 block text-2xl font-semibold text-text-primary"
            shallow
          >
            {community.name}
          </Link>
        </div>
        <div className="flex justify-end bg-background-primary/30 px-5 py-3">
          <PrimaryButton href={`/community/${community.path}`}>
            {t('community.button_enter_community.title')}
          </PrimaryButton>
        </div>
      </div>
      <Modal
        opened={opened}
        isCentered
        isFetching={isFetching}
        title={t('community.leave_modal_tittle', { name: community.name })}
        onClose={() => setOpened(false)}
      >
        <div className="flex flex-col gap-6 lg:gap-10">
          <p className="text-center text-base text-text-primary">
            {t('community.leave_modal_sub_title')}
          </p>
          <div className="flex justify-center gap-4 max-sm:flex-wrap">
            <DangerButton
              className="w-full text-base"
              width="large"
              isLoading={isFetching}
              onClick={() => onLeaveCommunity(community)}
            >
              {t('confirmation_modal.leave')} <ShapeIcon className="fill-background-secondary" />
            </DangerButton>
            <NeutralButton
              onClick={() => setOpened(false)}
              className="w-full text-base"
              width="large"
            >
              {t('confirmation_modal.cancel')}
            </NeutralButton>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CommunityCart
